import React from "react";
import { FaSpinner } from "react-icons/fa";

const ProcessingOverlay = ({ isProcessing, message }) => {
  return (
    <>
      {isProcessing && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="flex flex-col items-center space-y-4 p-6 bg-white rounded-lg shadow-lg">
            <FaSpinner className="animate-spin text-blue-500 text-4xl" />
            <p className="text-lg font-semibold text-gray-800">{message || "Processing..."}</p>
          </div>
        </div>
      )}
    </>
  );
};


export { ProcessingOverlay };
